import Prizes from './components/Prizes';
export default Prizes;